import { useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";

export const WarningModal = ({ show, setShowWarning }) => {
  const [toggle, setToggle] = useState(show);
  const Closeformfunction = () => {
    setToggle(false);
    setShowWarning(false);
  };
  return (
    <>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"WARNING"}
        TypeOfId={"Account Id :"}
        UserRightsPortal={false}
      >
        <div className="warningModalContainer">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Set Total Value To Given Adjestment Balance</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={Closeformfunction}
          submitType={"Okay"}
          TypeOfPortal={"WARNING"}
          disableupload={false}
        />
      </Reactportal>
    </>
  );
};
